module.exports = __webpack_public_path__ + "img/20.cbbeb834.png";